import axios from 'axios'

axios.interceptors.request.use(
  (config) => {

    const accessToken = localStorage.getItem('token')

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken.replace(/["]/g, '')}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error

    if (response && response.status === 401) {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      window.location.reload()
    }

    if (response && response.status === 500) {
      window.location.replace('/')
    }

    return Promise.reject(error)
  }
)

export default axios
